module.exports = __webpack_public_path__ + "static/media/APPLE_STORE.28cb8e9f.png";